/* Source unique du nombre de scoops — Scoop by Coralie, lot 102.

   Pourquoi ce fichier existe.

   Un panier se compte en scoops, jamais en euros : deux Scoops Premium à
   49,99 € font 99,98 € sans être trois scoops, et trois scoops de papeterie à
   33 € ne pèsent pas le même montant qu'un scoop beauté et deux skincare. Le
   nombre de scoops est donc une donnée métier au même titre qu'un prix : il
   n'est calculé qu'ici, et tout le thème — moteur de cadeaux, normalisation,
   fiche produit, panier — lit cette fonction.

   Depuis la décision D19 (12 septembre 2026), ce compte ne décide plus rien de
   la vidéo de préparation : elle est une option payante de chaque scoop, à
   toute taille, choisie sur la fiche produit. Le module n'expose donc plus ni
   seuil ni gratuité.

   D'où vient le nombre. De l'option « TAILLE DU SCOOP » de la variante, dont
   la valeur commence par le chiffre : « 1 Scoop (15–18 articles) » pour la
   Papeterie et la Beauté, « 2 Scoops (12 produits) » pour le Scoop Skincare.
   À défaut, du `variant_title`, qui reprend la même valeur en tête. Un libellé
   sans nombre vaut 0 : on ne devine jamais un scoop.

   Ce qui ne compte pas : un produit hors de la collection « Tous les Scoops »
   (liste `idsScoops` publiée par `snippets/sbc-cadeaux-config.liquid`), une
   carte-cadeau, et une ligne posée par le moteur en cadeau automatique — un
   cadeau ne débloque jamais un autre cadeau.

   Le module est utilisable des deux côtés : `module.exports` pour le test Node
   `tools/verif-scoops.test.mjs`, `window.SbcCompteScoops` pour le thème.
*/
(function (racine, fabrique) {
  var api = fabrique();
  if (typeof module === 'object' && module && module.exports) module.exports = api;
  if (racine) racine.SbcCompteScoops = api;
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  var OPTION_TAILLE = 'taille du scoop';
  /* Le nombre est en tête du libellé, suivi de « Scoop » ou « Scoops ». Ancré
     au début, le motif ne peut pas attraper le « 15/18 » du nombre d'articles
     ni un niveau de GOLD. */
  var MOTIF = /^\s*(\d+)\s*scoops?\b/i;

  var MARQUE_CADEAU = '_sbc_cadeau';
  var VALEUR_CADEAU = 'auto';

  var sansAccent = function (texte) {
    return String(texte == null ? '' : texte)
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .toLowerCase();
  };

  var nombreDansLibelle = function (libelle) {
    var trouve = MOTIF.exec(String(libelle == null ? '' : libelle));
    return trouve ? parseInt(trouve[1], 10) : 0;
  };

  /* Nombre de scoops d'UNE ligne de panier ou d'UNE variante de fiche produit,
     quantité non comprise. Les deux formes sont acceptées : une ligne de
     `/cart.js` porte `options_with_values` (nom + valeur) et `variant_title` ;
     une variante de `product.variants` porte `options` (valeurs seules). */
  var scoopsDeLaLigne = function (objet) {
    if (!objet || typeof objet !== 'object') return 0;

    var paires = Array.isArray(objet.options_with_values) ? objet.options_with_values : [];
    var i;
    for (i = 0; i < paires.length; i += 1) {
      if (paires[i] && sansAccent(paires[i].name) === OPTION_TAILLE) {
        return nombreDansLibelle(paires[i].value);
      }
    }
    /* Option non nommée : on essaie chaque valeur. Le motif étant ancré, seule
       une valeur de taille peut correspondre. */
    for (i = 0; i < paires.length; i += 1) {
      var parPaire = nombreDansLibelle(paires[i] && paires[i].value);
      if (parPaire > 0) return parPaire;
    }
    var options = Array.isArray(objet.options) ? objet.options : [];
    for (i = 0; i < options.length; i += 1) {
      var parOption = nombreDansLibelle(options[i]);
      if (parOption > 0) return parOption;
    }
    return nombreDansLibelle(objet.variant_title || objet.title);
  };

  var estCadeauAuto = function (ligne) {
    var props = (ligne && ligne.properties) || {};
    return props[MARQUE_CADEAU] === VALEUR_CADEAU;
  };

  /* Nombre de scoops d'un panier entier.
     `idsScoops` : identifiants de produits de la collection « Tous les Scoops ».
     Une liste vide ne vaut pas « tout compte » : elle vaut 0, parce qu'un
     panier ne doit jamais offrir une vidéo sur une liste qui n'a pas été
     rendue. */
  var compteScoops = function (items, idsScoops) {
    var lignes = Array.isArray(items) ? items : [];
    var autorises = {};
    var connus = 0;
    (Array.isArray(idsScoops) ? idsScoops : []).forEach(function (id) {
      var n = Number(id);
      if (n) { autorises[n] = true; connus += 1; }
    });
    if (!connus) return 0;

    return lignes.reduce(function (total, ligne) {
      if (!ligne || ligne.gift_card || estCadeauAuto(ligne)) return total;
      if (!autorises[Number(ligne.product_id)]) return total;
      var parLigne = scoopsDeLaLigne(ligne);
      if (parLigne <= 0) return total;
      var quantite = Number(ligne.quantity);
      if (!(quantite > 0)) quantite = 1;
      return total + parLigne * quantite;
    }, 0);
  };

  return {
    compteScoops: compteScoops,
    scoopsDeLaLigne: scoopsDeLaLigne
  };
});
